<div class="padding-1 primary-gradient-bg-100 m-2 clip3 search-container">
    <span class="search d-flex align-items-center search-bg clip3 h-100">
        <div class="form-group h-100">
            <input [formControl]="searchControl" (keydown.enter)="onSearch($event)" type="text"
                class="form-control border-0 primary-text ps-5 px-3 py-2 h-100">
        </div>
        <span class="material-icons-sharp font-8 position-absolute ms-3 primary-text-100">search</span>
    </span>
</div>